import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { canReadEntityOrTab } from '@/integrations/casl/route-ability'
import { getEntityTabLabel } from '@/lib/entity-route-i18n'

export const Route = createFileRoute(
	'/_authenticated/$entity/$entityId/settings',
)({
	beforeLoad: ({ params, context }) => {
		const entity = String(params.entity ?? '')
		const entityId = String(params.entityId ?? '')

		// Redirect to the default section if no section is provided in the URL
		// This ensures that users are always directed to a valid settings section
		if (!(params as unknown as { section?: string }).section) {
			return redirect({
				to: '/$entity/$entityId/settings/$section',
				params: {
					entity,
					entityId,
					section: 'general',
				},
			})
		}

		if (!canReadEntityOrTab(context.ability, entity, 'settings')) {
			throw new Error(
				`Missing read permission for tab "settings" on entity "${entity}"`,
			)
		}
	},
	component: Outlet,
	staticData: {
		breadcrumb: () => ({ label: getEntityTabLabel('settings') }),
	},
})
